export const STRIPE_CONNECTED_ACCOUNT_TOS_URL = "https://images.stripeassets.com/fzn2n1nzq965/6grOg493jfRyiWTOngIGCZ/ebd61ccab3cca22f432930c560af74b4/Canada__French__-_Stripe_Connected_Account_Agreement__2025-Nov-18_.pdf";
